/* Pause animations that nobody is looking at.

   Home ships 21 infinite CSS animations. Measured at the top of the page, only
   7 of them are on screen - the other 14 (the press marquee, the community fan
   ring and 12 vitrine motes) sit below the fold and tick on every single frame
   anyway, for the whole time the tab is open.

   Mechanism: each animated section carries [data-anim-scope]. This observes
   them and toggles `is-anim-idle`, which each section's own stylesheet turns
   into `animation-play-state: paused` for its own animated selectors. Keeping
   the selector list in the section rather than here means a section that grows
   a new animation declares it in the same file, instead of silently escaping a
   list kept somewhere else.

   `paused` resumes exactly where it stopped, so the marquee and the fan never
   jump - which is why this is a pause and not a `animation: none`.

   FAIL-OPEN, deliberately, and this is the opposite polarity to depth.js.
   depth.js has to guard against content staying invisible, so it degrades by
   revealing everything. Here the class is only ever ADDED off the back of a
   positive "this is off screen" report: if the script never loads, or
   IntersectionObserver is missing, nothing is ever marked idle and every
   animation runs exactly as it does today. The failure mode is "no
   optimisation", never "a frozen page". Do not invert this to an
   `is-anim-active` opt-in - that would make a script failure look like broken
   animations. */
(function () {
  var SCOPE = '[data-anim-scope]';
  var IDLE = 'is-anim-idle';

  if (!('IntersectionObserver' in window)) return;

  /* Last known intersection state per scope. WeakMap so a section the theme
     editor tears out is not retained here. */
  var visible = new WeakMap();

  function apply(el) {
    /* Unknown => treat as on screen. Only a positive off-screen report pauses,
       which is what keeps the whole thing fail-open. */
    var onScreen = visible.get(el) !== false;
    var idle = document.hidden || !onScreen;
    el.classList.toggle(IDLE, idle);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      visible.set(entry.target, entry.isIntersecting);
      apply(entry.target);
    });
  }, {
    /* Resume a screen's-worth early so nothing is caught mid-start as it
       scrolls in - the marquee in particular reads as broken if it visibly
       begins moving only once it is already in view. threshold 0: a single
       visible pixel is enough to count as watched. */
    rootMargin: '200px 0px 200px 0px',
    threshold: 0
  });

  function observe(scope) {
    (scope || document).querySelectorAll(SCOPE).forEach(function (el) {
      if (el.dataset.animBound) return;
      el.dataset.animBound = '1';
      observer.observe(el);
    });
  }

  /* Switching tabs is the other half of "not looking at it". Browsers throttle
     background tabs but do not reliably stop compositor-driven animations, so
     say it explicitly. Re-applies from the stored intersection state on the way
     back, rather than assuming everything became visible. */
  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll(SCOPE).forEach(apply);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(document); });
  } else {
    observe(document);
  }

  /* Theme editor replaces a section's DOM wholesale; the new node has no
     data-animBound, so this simply picks it up. */
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target || document);
  });
})();
